import Pagination from "@mui/material/Pagination";

function ViewWithPagination(props) {
	return (
		<div className="flex flex-col flex-1 h-100 p-relative">
			{props.children}
			<Pagination
				className="pagination--row"
				count={props.count}
				siblingCount={0}
				onChange={(_e, page) => {
					props.scrollToTop();
					props.setPage(page - 1);
				}}
				page={props.page + 1}
			/>
		</div>
	);
}

export default ViewWithPagination;
